import LeagueTeamIndex from './LeagueTeamIndex';
import LeagueTeamCreate from './LeagueTeamCreate';
import LeagueTeamSettings from './LeagueTeamSettings';
import LeagueTeamSingle from './LeagueTeamSingle';

export default function (app) {

    const settings = LeagueTeamSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeagueTeamIndex(app, settings);

    LeagueTeamCreate(app, settings);

    LeagueTeamSingle(app, settings);

}